/**
 * Old hash-router URLs (`/#/dashboard/dwa-web-banners`, `/#/lupa-admin`, …) from
 * before react-router. Bookmarks and links in old emails/chats keep working: the
 * hash path becomes the real path. Path names didn't change, except the old
 * `/petal-admin` alias, which the router redirects to `/lupa-admin`.
 *
 * Only `#/…` hashes are legacy routes. Other fragments (e.g. `#page=3` on a
 * document link) are left alone.
 */
export function legacyHashToPath(hash: string): string | null {
  if (!hash.startsWith('#/')) return null;
  const path = hash.slice(1);
  return path === '' ? '/' : path;
}
